import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=52a3a3f6&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=52a3a3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3a3f6",
  null
  
)

export default component.exports